import { useEffect, useState } from 'react'

interface ThemeTransitionProps {
  active: boolean
  onComplete: () => void
}

export default function ThemeTransition({ active, onComplete }: ThemeTransitionProps) {
  const [phase, setPhase] = useState<'idle' | 'flicker' | 'text' | 'fade'>('idle')

  useEffect(() => {
    if (!active) {
      setPhase('idle')
      return
    }

    setPhase('flicker')
    const t1 = setTimeout(() => setPhase('text'), 150)
    const t2 = setTimeout(() => setPhase('fade'), 600)
    const t3 = setTimeout(() => {
      setPhase('idle')
      onComplete()
    }, 900)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
      clearTimeout(t3)
    }
  }, [active, onComplete])

  if (phase === 'idle') return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: phase === 'flicker' ? '#fff' : '#000',
        opacity: phase === 'fade' ? 0 : 1,
        transitionProperty: 'opacity',
        transitionDuration: '0.3s',
        fontFamily: "'Courier New', monospace",
      }}
      aria-live="assertive"
    >
      {(phase === 'text' || phase === 'fade') && (
        <span
          style={{
            color: '#00ff00',
            fontSize: '1.5rem',
            letterSpacing: '0.2em',
            textShadow: '0 0 10px #00ff00',
          }}
        >
          ACCESS GRANTED
        </span>
      )}
    </div>
  )
}
